import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Modal,
  Offcanvas,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../Common/BreadCrumb";
import { categoryListData } from "../../../Common/data";
import FormProvider from "../../../FunctionalComponent/FormElement/FormProvider";
import RHFTextField from "../../../FunctionalComponent/FormElement/RHTextField";
import * as Yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import RHSelectField from "../../../FunctionalComponent/FormElement/RHSelectField";
import RHTextarea from "../../../FunctionalComponent/FormElement/RHTextarea";
import { useUplaodFileMutation } from "../../../Redux/file/fileApi";
import {
  useCategoryListMutation,
  useCreateCategoryMutation,
  useDeleteCategoryMutation,
} from "../../../Redux/category/categoryApi";
import { toast } from "react-toastify";
import DeleteModal from "../../../Common/modals/DeleteModal";
import { getQueryString } from "../../../lib/Validationtext";
import useDebounce from "../../../hooks/useDebounce";
import moment from "moment";
import CustomModal from "../../../Common/modals/CustomModal";
const Categories = () => {
  document.title = "Categories | Toner eCommerce + Admin React Template";
  const [fileUploadFn, { data: fileData }] = useUplaodFileMutation();
  const [createCategoryFn, { data, isSuccess, error, isLoading }] =
    useCreateCategoryMutation();
  const [
    categoryListFn,
    { data: listData, error: listErr, isLoading: listLoading },
  ] = useCategoryListMutation();
  const [
    deleteCategoryFn,
    {
      data: deleteData,
      error: deleteErr,
      isLoading: deleteLoading,
      isSuccess: deleteSuccess,
    },
  ] = useDeleteCategoryMutation();
  const [showModal, setShowModal] = useState(false);
  const [showModalUpdateConfirm, setShowModalUpdateConfirm] = useState(false);

  const [search, setSearch] = useState("");
  const debounceSearch = useDebounce(search, 300);
  const [show, setShow] = useState(false);
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [datesFilter, setDatesFilter] = useState({});
  const [showDetails, setshowDetails] = useState({});

  const [info, setInfo] = useState([]);

  const [categoryImage, setcategoryImage] = useState(null);
  const [icon, seticon] = useState(null);
  const [banner, setbanner] = useState(null);

  // Pagination
  const [pagination, setPagination] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentpages, setCurrentpages] = useState([]);

  const [editId, setEditId] = useState("");

  const perPageData = 9;

  const handleClick = (e) => {
    setCurrentPage(Number(e.target.id));
  };

  const indexOfLast = currentPage * perPageData;
  const indexOfFirst = indexOfLast - perPageData;

  // const currentdata = useMemo(() => categoryListData.slice(indexOfFirst, indexOfLast), [indexOfFirst, indexOfLast])

  // useEffect(() => {
  //     setCurrentpages(currentdata)
  // }, [currentPage, currentdata])

  const pageNumbers = Array(listData?.additional?.pageSize || 0)
    .fill("")
    .map((_, i) => i + 1);
  // for (let i = 1; i <= Math.ceil(categoryListData.length / perPageData); i++) {
  //     pageNumbers.push(i);
  // }

  const handleprevPage = () => {
    let prevPage = currentPage - 1;
    setCurrentPage(prevPage);
  };

  const handlenextPage = () => {
    let nextPage = currentPage + 1;
    setCurrentPage(nextPage);
  };

  useEffect(() => {
    if (pageNumbers.length && pageNumbers.length < currentPage) {
      setCurrentPage(pageNumbers.length);
    }
  }, [currentPage, pageNumbers.length]);

  const categorySchema = Yup.object().shape({
    name: Yup.string()
      .required()
      .strict(true)
      .trim("White spaces before and after are not allowed"),

    slug: Yup.string().matches(
      /^\S+$/,
      "String should contain at least one non-space character"
    ),

    isActive: Yup.string().required("Status is required"),

    isShowInNavbar: Yup.string().required(
      "Show in navbar status required is required"
    ),

    // isShowInHeader: Yup.string().required('Show in header status required is required'),

    sortDescription: Yup.string().required().strict(true),

    longDescription: Yup.string().required().strict(true),

    // showInHeaders: Yup.string()
    //     .required()
    //     .strict(true),
  });

  const defaultValues = {
    id: "",
    name: "",
    slug: "",
    parentId: "",
    isActive: 1,
    isDisplayHomePage: false,
    isShowInNavbar: false,
    isShowInHeader: false,
    sortDescription: "",
    // showInHeaders: '',
    longDescription: "",
    metaTitle: "",
    metaTag: "",
    metaDescription: "",
    categoryImage: "",
    icon: "",
    banner: "",
    offer: "",
    quotation: "",
    // showInCategoryHomepageOrder: ''
  };

  const methods = useForm({
    resolver: yupResolver(categorySchema),
    defaultValues,
    mode: "all",
  });

  const {
    reset,
    setError,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors },
  } = methods;

  const onSubmit = async (data, isUpdated) => {
    console.log("data", data);
    console.log(
      "getValues",
      getValues("categoryImage"),
      getValues("icon"),
      getValues("banner")
    );

    if (!data.categoryImage) {
      toast.error("Category image is a required field.");
      return; // Return here to avoid hitting the API
    }

    // if (!data.icon) {
    //   toast.error('Icon image is a required field.');
    //   return; // Return here to avoid hitting the API
    // }

    // if (!data.banner) {
    //   toast.error('Banner image is a required field.');
    //   return; // Return here to avoid hitting the API
    // }

    try {
      const promiseAll = await Promise.all([
        uploadFile(categoryImage),
        uploadFile(icon),
        uploadFile(banner),
      ]);

      const resData = createCategoryFn({
        ...data,
        categoryImage: data?.categoryImage === "" ? "" : promiseAll[0],
        icon: data?.icon === "" ? "" : promiseAll[1],
        banner: data?.banner === "" ? "" : promiseAll[2],
      });
      console.log("resData", resData);

      if (!isUpdated) {
        setcategoryImage(null);
        seticon(null);
        setbanner(null);
        setShowModalUpdateConfirm(false);
        reset();
      }

      return resData;
    } catch (error) {
      setShowModalUpdateConfirm(false);
      setError("afterSubmit", {
        ...error,
        message: error.message,
      });
    }
  };

  // State to control whether to show the image or not
  const [showCategoryImage, setShowCategoryImage] = useState(true);
  const [showIconImage, setShowIconImage] = useState(true);
  const [showBannerImage, setShowBannerImage] = useState(true);

  const handleDeleteImage = (imageType) => {
    if (imageType == "categoryImage") {
      console.log("Deleting", imageType, "image...");
      setValue("categoryImage", ""); // Clear the specific image type
      setShowCategoryImage(false);
    } else if (imageType == "icon") {
      console.log("Deleting", imageType, "image...");
      setValue("icon", ""); // Clear the specific image type
      setShowIconImage(false);
    } else if (imageType == "banner") {
      console.log("Deleting", imageType, "image...");
      setValue("banner", ""); // Clear the specific image type
      setShowBannerImage(false);
    }
  };

  const handleFileChange = async (e, setFile, name) => {
    const file = e.target.files?.[0];
    const fileName = e.target.name;
    setShowCategoryImage(true);
    setShowIconImage(true);
    setShowBannerImage(true);
    // Define an object to map filenames to their respective maximum file sizes
    const maxFileSizeMap = {
      icon: 1024 * 2, // 2MB for icon
      categoryImage: 1024 * 10, // 10MB for category
      banner: 1024 * 10, // 10MB for banner
    };

    // Get the maximum file size based on the filename
    const maxSizeKB = maxFileSizeMap[fileName];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (reader.readyState === 2) {
          const fileSize = file.size / 1024; // file size in KB
          const allowedTypes = ["image/jpeg", "image/png", "image/webp"];

          // Validate file type
          if (!allowedTypes.includes(file.type)) {
            toast.error(
              "Image type not supported. Please choose a jpg, jpeg, png, or webp file."
            );
            return;
          }

          // Validate file size
          if (fileSize > maxSizeKB) {
            toast.error(
              `File size exceeds maximum limit (${
                maxSizeKB / 1024
              }MB). Please choose a smaller file.`
            );
            return;
          }

          // Set the value based on the filename
          switch (fileName) {
            case "categoryImage":
              setCategoryImage(reader.result, file);
              break;
            case "icon":
              setIcon(reader.result, file);
              break;
            case "banner":
              setBanner(reader.result, file);
              break;
            default:
              console.error("Invalid filename:", fileName);
          }
        }
      };
      reader.readAsDataURL(file);
      setFile(file);
    }
  };

  const setCategoryImage = (result, file) => {
    setValue("categoryImage", result, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  };

  const setIcon = (result, file) => {
    setValue("icon", result, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  };

  const setBanner = (result, file) => {
    setValue("banner", result, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  };

  const uploadFile = async (file) => {
    if (!file) {
      // If there's no file to upload, resolve immediately
      return;
    }

    try {
      const formData = new FormData();
      formData.append("image", file);

      const response = await fileUploadFn(formData);
      return response?.data?.response?.url;
    } catch (error) {
      throw error;
    }
  };

  // const [selectCategory, setSelectedCategory] = useState({})

  useEffect(() => {
    if (isSuccess) {
      const message = data?.message || "Login success";
      toast.success(message);
    }
    if (error) {
      if ("data" in error) {
        const errorData = error;
        toast.error(errorData.data.message);

        if (
          error?.data?.message?.includes("CategoryHomepageOrder is already")
        ) {
          // setSelectedCategory(error?.data?.showInCategoryHomepageOrder)
          setShowModalUpdateConfirm(true);
        }
      }
    }
  }, [data, isSuccess, error]);

  useEffect(() => {
    // deleteData, error: deleteErr, isLoading: deleteLoading,deleteSuccess
    if (deleteSuccess) {
      setShowModal(false);
      const message = deleteData?.message || "Delete successfully";
      toast.success(message);
      setInfo({});
      setShow(false);
    }
    if (deleteErr) {
      if ("data" in deleteErr) {
        const errorData = deleteErr;
        toast.error(errorData.data.message);
      }
    }
  }, [deleteData, deleteSuccess, deleteErr]);

  useEffect(() => {
    categoryListFn(
      getQueryString({
        page: currentPage,
        limit: 25,
        search: debounceSearch,
        ...datesFilter,
      })
    );
    // moment().format('L')
  }, [currentPage, debounceSearch, datesFilter, deleteSuccess, isSuccess]);

  const [deleteItem, setDeleteItem] = useState("");

  let listContent = null;
  // listData, error: listErr, isLoading: listLoading
  if (listLoading) {
    listContent = <p>Loading...</p>;
  } else if (listErr && !listLoading) {
    listContent = <p>Something went wrong</p>;
  } else if (!listErr && !listLoading && listData?.response?.length == 0) {
    listContent = <p>No Category available</p>;
  } else if (!listErr && !listLoading && listData?.response?.length > 0) {
    listContent = (
      <>
        {" "}
        <Row id="categories-list">
          {listData?.response?.map((item, key) => (
            <Col xxl={4} md={6} key={key}>
              <Card className="categrory-widgets overflow-hidden">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-3">
                    <h5 className="flex-grow-1 mb-0">{item?.name}</h5>
                    <ul className="flex-shrink-0 list-unstyled hstack gap-1 mb-0">
                      <li>
                        <Link
                          to="#"
                          className="badge bg-info-subtle text-info"
                          onClick={() => {
                            for (const key in defaultValues) {
                              if (
                                Object.hasOwnProperty.call(defaultValues, key)
                              ) {
                                let element = item[key] || "";
                                if (key === "isActive") {
                                  element =
                                    item[key]?.toString() === "true" ? 1 : 0;
                                }
                                if (key === "isDisplayHomePage") {
                                  element =
                                    item[key]?.toString() === "true"
                                      ? true
                                      : false;
                                }
                                if (key === "isShowInNavbar") {
                                  element =
                                    item[key]?.toString() === "true"
                                      ? true
                                      : false;
                                }
                                if (key === "isShowInHeader") {
                                  element =
                                    item[key]?.toString() === "true"
                                      ? true
                                      : false;
                                }

                                setValue(key, element, {
                                  shouldDirty: true,
                                  shouldTouch: true,
                                  shouldValidate: true,
                                });
                              }
                            }
                            setEditId(item?.id);
                          }}
                        >
                          Edit
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          data-bs-toggle="modal"
                          className="badge bg-danger-subtle text-danger"
                          onClick={() => {
                            setDeleteItem(item);
                            setShowModal(true);
                          }}
                        >
                          Delete
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <ul className="list-unstyled vstack gap-2 mb-0">
                    {
                      listData?.response?.find((it) => it?.id == item?.parentId)
                        ?.name
                    }
                    {/* {item?.subCategories?.map((item, key) => (key < 4 && <li key={key}><Link to="#" className="text-muted">{item?.name}</Link></li>))} */}
                  </ul>
                  <div className="mt-3">
                    <Link
                      to="#"
                      className="fw-medium link-effect"
                      onClick={() => {
                        setShow(true);
                        setInfo(item);
                      }}
                    >
                      Read More{" "}
                      <i className="ri-arrow-right-line align-bottom ms-1"></i>
                    </Link>
                  </div>
                  <img
                    src={item?.categoryImage}
                    alt=""
                    className="img-fluid category-img object-fit-cover"
                    style={{ pointerEvents: "none" }}
                  />
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        {pagination && (
          <Row id="pagination-element" className="mb-4">
            <Col lg={12}>
              <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                <div
                  className={
                    currentPage <= 1 ? "page-item disabled" : "page-item"
                  }
                >
                  <Button
                    variant="link"
                    href="#"
                    className="page-link"
                    id="page-prev"
                    onClick={() => handleprevPage()}
                  >
                    ←
                  </Button>
                </div>
                <span id="page-num" className="pagination">
                  {pageNumbers.map((item, key) => (
                    <React.Fragment key={key}>
                      <div
                        className={
                          currentPage === item
                            ? "page-item active"
                            : "page-item"
                        }
                      >
                        <Link
                          className="page-link clickPageNumber"
                          to="#"
                          key={key}
                          id={item}
                          onClick={(e) => handleClick(e)}
                        >
                          {item}
                        </Link>
                      </div>
                    </React.Fragment>
                  ))}
                </span>
                <div
                  className={
                    currentPage >= pageNumbers.length
                      ? "page-item disabled"
                      : "page-item"
                  }
                >
                  <Button
                    variant="link"
                    href="#"
                    className="page-link"
                    id="page-next"
                    onClick={() => handlenextPage()}
                  >
                    →
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </>
    );
  }

  const handleFilterDate = (value) => {
    console.log("value", value);
    const monthNumber = moment().month() + 1; // Add 1 to get the 1-based month number

    const currentDate = moment();
    const firstDayOfMonth = currentDate.startOf("month");
    const formattedFirstDay = firstDayOfMonth.format("YYYY-MM-DD");
    const currentYear = moment().year();
    const startDate = moment(`1/1/${currentYear}`, "YYYY-MM-DD");
    const formattedStartDate = currentDate
      .clone()
      .subtract(1, "month")
      .format("YYYY-MM-DD");

    const yesterday = moment().subtract(1, "days");

    // Get the last date of the current month
    const lastDateOfMonth = currentDate.endOf("month");

    // Get the last date of the previous month

    const last7days = moment().subtract(7, "days").format("YYYY-MM-DD");

    switch (value) {
      case "All":
        setDatesFilter({ from: "", to: "" });
        return;
      case "Today":
        setDatesFilter({
          from: moment(new Date()).format("YYYY-MM-DD"),
          to: moment(new Date()).format("YYYY-MM-DD"),
        });
        return;
      case "Yesterday":
        setDatesFilter({
          from: yesterday.format("YYYY-MM-DD"),
          to: moment(new Date()).format("YYYY-MM-DD"),
        });
        return;
      case "Last 7 Days":
        setDatesFilter({
          from: last7days,
          to: moment(new Date()).format("YYYY-MM-DD"),
        });
        return;
      case "Last 30 Days":
        setDatesFilter({
          from: moment().subtract(30, "days").format("YYYY-MM-DD"),
          to: moment(new Date()).format("YYYY-MM-DD"),
        });
        return;
      case "This Month":
        setDatesFilter({
          from: formattedFirstDay,
          to: lastDateOfMonth.format("YYYY-MM-DD"),
        });
        return;
      case "Last Month":
        setDatesFilter({
          from: formattedStartDate,
          to: lastDateOfMonth.format("YYYY-MM-DD"),
        });
        return;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Categories" pageTitle="Products" />
          <Row>
            <Col xxl={3}>
              <Card>
                <Card.Header>
                  <h6 className="card-title mb-0">
                    {getValues("id") ? "Edit" : "Create"} Categories
                  </h6>
                </Card.Header>
                <Card.Body>
                  <FormProvider
                    methods={methods}
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <Row>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3">
                          <RHFTextField
                            name="name"
                            label="Category Name"
                            required
                            onChange={(e) => {
                              setValue("name", e.target.value, {
                                shouldDirty: true,
                                shouldTouch: true,
                                shouldValidate: true,
                              });
                              setValue(
                                "slug",
                                e.target.value
                                  .toLowerCase()
                                  .replace(/&/g, "and")
                                  .replace(/ /g, "_"),
                                {
                                  shouldDirty: true,
                                  shouldTouch: true,
                                  shouldValidate: true,
                                }
                              );
                            }}
                          />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3">
                          <RHFTextField name="slug" label="Slug" required />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3 ">
                          <RHSelectField
                            name="parentId"
                            label="Parent Category"
                            list={
                              (listData?.response?.length &&
                                listData?.response?.map((item) => ({
                                  name: item?.name,
                                  value: item?.id,
                                }))) || [{}]
                            }
                          />
                        </div>
                      </Col>
                      {/* <Col xxl={12} lg={6}>
                                                <div className="mb-3">
                                                    <RHSelectField name='showInHeaders' required label='Show in header' list={[
                                                        { name: 'Active', value: 1 },
                                                        { name: 'Inactive', value: 0 },
                                                    ]} />
                                                </div>
                                            </Col> */}
                      <Col xxl={12} lg={6}>
                        <div className="mb-3 ">
                          <RHSelectField
                            name="isActive"
                            required
                            label="Status"
                            list={[
                              { name: "Active", value: 1 },
                              { name: "Inactive", value: 0 },
                            ]}
                          />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3 ">
                          <RHSelectField
                            name="isShowInNavbar"
                            required
                            label="Show In Navbar"
                            list={[
                              { name: "Active", value: true },
                              { name: "Inactive", value: false },
                            ]}
                          />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3 ">
                          <RHSelectField
                            name="isShowInHeader"
                            label="Show in trending"
                            list={[
                              { name: "Active", value: true },
                              { name: "Inactive", value: false },
                            ]}
                          />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3 ">
                          <RHSelectField
                            name="isDisplayHomePage"
                            required
                            label="Display as a category in homepage"
                            list={[
                              { name: "Active", value: true },
                              { name: "Inactive", value: false },
                            ]}
                          />
                        </div>
                      </Col>
                      {/* <Col xxl={12} lg={6}>
                        <div className="mb-3 ">
                          <RHSelectField name='showInCategoryHomepageOrder' required label='Display Order' list={[
                            { name: 'Order 1', value: 1 },
                            { name: 'Order 2', value: 2 },
                            { name: 'Order 3', value: 3 },
                          ]} />
                        </div>
                      </Col> */}
                      <Col xxl={12} lg={6}>
                        <div className="mb-3">
                          <RHTextarea
                            label="Short Description"
                            name="sortDescription"
                            required
                          />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3">
                          <RHTextarea
                            label="Long Description"
                            name="longDescription"
                            rows={3}
                            sortDescription
                            required
                          />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3">
                          <RHFTextField
                            label="Category Offer"
                            name="offer"
                            rows={2}
                          />
                        </div>
                      </Col>{" "}
                      <Col xxl={12} lg={6}>
                        <div className="mb-3">
                          <RHFTextField
                            label="Category Quotation"
                            name="quotation"
                            rows={2}
                          />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3">
                          <RHFTextField
                            label="Meta Title"
                            name="metaTitle"
                            rows={2}
                          />
                        </div>
                      </Col>{" "}
                      <Col xxl={12} lg={6}>
                        <div className="mb-3">
                          <RHFTextField
                            label="Meta Tag"
                            name="metaTag"
                            rows={2}
                          />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6}>
                        <div className="mb-3">
                          <RHTextarea
                            label="Meta Description"
                            name="metaDescription"
                            rows={2}
                          />
                        </div>
                      </Col>
                      <Col xxl={12} lg={6} className="mb-3">
                        <div className="mb-3">
                          <Form.Label
                            htmlFor={
                              getValues("categoryImage") ? "" : "categoryImage"
                            }
                            className="form-label d-block"
                          >
                            Category Image{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <div className="position-relative d-inline-block">
                            <div className="position-absolute top-100 start-100 translate-middle">
                              <Form.Label
                                htmlFor={
                                  getValues("categoryImage")
                                    ? ""
                                    : "categoryImage"
                                }
                                className="mb-0"
                                data-bs-toggle="tooltip"
                                data-bs-placement="right"
                                title="Select Category Image"
                              >
                                <span className="avatar-xs d-inline-block">
                                  <span className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                    {getValues("categoryImage") &&
                                    showCategoryImage ? (
                                      <i
                                        className="ri-delete-bin-5-line"
                                        onClick={() =>
                                          handleDeleteImage("categoryImage")
                                        }
                                      ></i>
                                    ) : (
                                      <i
                                        className="ri-image-fill"
                                        onClick={() =>
                                          setShowCategoryImage(
                                            !showCategoryImage
                                          )
                                        }
                                      ></i>
                                    )}
                                  </span>
                                </span>
                              </Form.Label>
                              {showCategoryImage && (
                                <input
                                  className="form-control d-none"
                                  name="categoryImage"
                                  id="categoryImage"
                                  type="file"
                                  onChange={(e) =>
                                    handleFileChange(e, setcategoryImage)
                                  }
                                />
                              )}
                            </div>
                            <div className="avatar-lg">
                              <div className="avatar-title bg-light rounded-3">
                                {getValues("categoryImage") &&
                                showCategoryImage ? (
                                  <img
                                    src={getValues("categoryImage")}
                                    alt=""
                                    id="category-img"
                                    className="avatar-md h-auto rounded-3 object-fit-cover"
                                  />
                                ) : (
                                  <img
                                    src="#"
                                    alt=""
                                    id="category-img"
                                    className="avatar-md h-auto rounded-3 object-fit-cover"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col xxl={12} lg={6} className="mb-3">
                        <div className="mb-3">
                          <Form.Label
                            htmlFor={getValues("icon") ? "" : "icon"}
                            className="form-label d-block"
                          >
                            Icon Image{" "}
                          </Form.Label>
                          <div className="position-relative d-inline-block">
                            <div className="position-absolute top-100 start-100 translate-middle">
                              <Form.Label
                                htmlFor={getValues("icon") ? "" : "icon"}
                                className="mb-0"
                                data-bs-toggle="tooltip"
                                data-bs-placement="right"
                                title="Select Category Image"
                              >
                                <span className="avatar-xs d-inline-block">
                                  <span className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                    {getValues("icon") && showIconImage ? (
                                      <i
                                        className="ri-delete-bin-5-line"
                                        onClick={() =>
                                          handleDeleteImage("icon")
                                        }
                                      ></i>
                                    ) : (
                                      <i
                                        className="ri-image-fill"
                                        onClick={() =>
                                          setShowIconImage(!showIconImage)
                                        }
                                      ></i>
                                    )}
                                  </span>
                                </span>
                              </Form.Label>
                              {showIconImage && (
                                <input
                                  className="form-control d-none"
                                  id="icon"
                                  type="file"
                                  name="icon"
                                  onChange={(e) => handleFileChange(e, seticon)}
                                />
                              )}

                              {/* accept="image/png, image/gif, image/jpeg" */}
                            </div>
                            <div className="avatar-lg">
                              {getValues("icon") && showIconImage ? (
                                <div className="avatar-title bg-light rounded-3">
                                  <img
                                    src={getValues("icon")}
                                    alt=""
                                    id="category-img"
                                    className="avatar-md h-auto rounded-3 object-fit-cover"
                                  />
                                </div>
                              ) : (
                                <div className="avatar-title bg-light rounded-3">
                                  <img
                                    src="#"
                                    alt=""
                                    id="category-img"
                                    className="avatar-md h-auto rounded-3 object-fit-cover"
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          {/* <div className="error-msg mt-1">Please add a category images.</div> */}
                          {/* <p>{errors?.icon?.message}</p> */}
                        </div>
                      </Col>
                      <Col xxl={12} lg={6} className="mb-3">
                        <div className="mb-3">
                          <Form.Label
                            htmlFor={getValues("banner") ? "" : "banner"}
                            className="form-label d-block"
                          >
                            Banner Image{" "}
                          </Form.Label>
                          <div className="position-relative d-inline-block">
                            <div className="position-absolute top-100 start-100 translate-middle">
                              <Form.Label
                                htmlFor={getValues("banner") ? "" : "banner"}
                                className="mb-0"
                                data-bs-toggle="tooltip"
                                data-bs-placement="right"
                                title="Select Category Image"
                              >
                                <span className="avatar-xs d-inline-block">
                                  <span className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                    {getValues("banner") && showBannerImage ? (
                                      <i
                                        className="ri-delete-bin-5-line"
                                        onClick={() =>
                                          handleDeleteImage("banner")
                                        }
                                      ></i>
                                    ) : (
                                      <i
                                        className="ri-image-fill"
                                        onClick={() =>
                                          setShowBannerImage(!showBannerImage)
                                        }
                                      ></i>
                                    )}
                                  </span>
                                </span>
                              </Form.Label>
                              {showBannerImage && (
                                <input
                                  className="form-control d-none"
                                  id="banner"
                                  type="file"
                                  onChange={(e) =>
                                    handleFileChange(e, setbanner)
                                  }
                                  name="banner"
                                />
                              )}
                            </div>
                            <div className="avatar-lg">
                              {getValues("banner") && showBannerImage ? (
                                <div className="avatar-title bg-light rounded-3">
                                  <img
                                    src={getValues("banner")}
                                    alt=""
                                    id="category-img"
                                    className="avatar-md h-auto rounded-3 object-fit-cover"
                                  />
                                </div>
                              ) : (
                                <div className="avatar-title bg-light rounded-3">
                                  <img
                                    src="#"
                                    alt=""
                                    id="category-img"
                                    className="avatar-md h-auto rounded-3 object-fit-cover"
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          {/* <p>{errors?.banner?.message}</p> */}
                        </div>
                      </Col>
                    </Row>

                    <Button
                      variant="success"
                      className="d-flex align-items-center"
                      disabled={isLoading}
                      type="submit"
                    >
                      {isLoading && (
                        <Spinner
                          animation="border"
                          variantn="secondary"
                          size="sm"
                        />
                      )}

                      <p className="mb-0 ps-2">
                        {" "}
                        {editId ? "Update Category" : "Add Category"}
                      </p>
                    </Button>
                  </FormProvider>
                </Card.Body>
              </Card>
            </Col>
            <Col xxl={9}>
              <Row className="justify-content-between mb-4">
                {/* <Col xxl={3} lg={6}>
                                    <div className="search-box mb-3 mb-lg-0">
                                        <Form.Control type="text" id="searchInputList" placeholder="Search Product" onChange={(e) => setSearch(e.target.value)} />
                                        <i className="ri-search-line search-icon"></i>
                                    </div>
                                </Col> */}
                <Col xxl={2} lg={6}>
                  <select
                    className="form-select"
                    data-choices
                    data-choices-search-false
                    name="choices-single-default"
                    id="idStatus"
                    onChange={(e) => handleFilterDate(e.target.value)}
                  >
                    <option defaultValue="all">All</option>
                    <option value="Today">Today</option>
                    <option value="Yesterday">Yesterday</option>
                    <option value="Last 7 Days">Last 7 Days</option>
                    <option value="Last 30 Days">Last 30 Days</option>
                    <option value="This Month">This Month</option>
                    <option value="Last Month">Last Month</option>
                  </select>
                </Col>
              </Row>

              {listContent}
            </Col>
          </Row>
        </Container>
      </div>
      <Offcanvas show={show} onHide={() => setShow(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>#{info?.name}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="avatar-lg mx-auto">
            <div className="avatar-title bg-light rounded">
              <img
                src={info?.categoryImage}
                alt=""
                className="avatar-sm overview-img"
              />
            </div>
          </div>
          <div className="text-center mt-3">
            <h5 className="overview-title">{info?.categoryTitle}</h5>
            <p className="text-muted">
              by{" "}
              <Link to="#" className="text-reset">
                Admin
              </Link>
            </p>
          </div>

          <h6 className="fs-14">Description</h6>
          <p className="text-muted overview-desc">{info?.longDescription}</p>

          <h6 className="fs-14 mb-3">Sub Categories</h6>
          <ul
            className="vstack gap-2 mb-0 subCategory"
            style={{ listStyleType: "circle" }}
          >
            {(info?.subCategories || []).map(
              (item, key) =>
                key < 4 && (
                  <li key={key}>
                    <Link to="#" className="text-reset">
                      {item?.name}
                    </Link>
                  </li>
                )
            )}
          </ul>
        </Offcanvas.Body>
        <div className="p-3 border-top">
          <Row>
            <Col sm={6}>
              <div data-bs-dismiss="offcanvas">
                <Button
                  variant="danger"
                  type="button"
                  className="btn btn-danger w-100 remove-list"
                  data-bs-toggle="modal"
                  data-bs-target="#delteModal"
                  data-remove-id="12"
                  onClick={() => {
                    setDeleteItem(info);
                    setShowModal(true);
                  }}
                >
                  <i className="ri-delete-bin-line me-1 align-bottom"></i>{" "}
                  Delete
                </Button>
              </div>
            </Col>
            <Col sm={6}>
              <Button
                variant="secondary"
                type="button"
                className="w-100 edit-list"
                data-bs-dismiss="offcanvas"
                data-edit-id="12"
                onClick={() => {
                  for (const key in defaultValues) {
                    if (Object.hasOwnProperty.call(defaultValues, key)) {
                      let element = info[key] || "";
                      if (key === "isActive") {
                        element = info[key]?.toString() === "true" ? 1 : 0;
                      }
                      setValue(key, element, {
                        shouldDirty: true,
                        shouldTouch: true,
                        shouldValidate: true,
                      });
                    }
                  }
                  setEditId(info?.id);

                  setShow(false);
                  setInfo({});
                }}
              >
                <i className="ri-pencil-line me-1 align-bottom"></i> Edit
              </Button>
            </Col>
          </Row>
        </div>
      </Offcanvas>

      <DeleteModal
        showModal={showModal}
        loading={deleteLoading}
        setShowModal={setShowModal}
        data={deleteItem}
        handleSubmit={() => deleteCategoryFn(deleteItem?.id)}
      />

      {/* <CustomModal showModal={showModalUpdateConfirm} handleClose={() => setShowModalUpdateConfirm(false)} >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Modal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectCategory?.name} is already order {getValues('showInCategoryHomepageOrder')} {' , '}
          Are you sure to update?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalUpdateConfirm(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={async () => {
            const updateCatgoryData = await onSubmit({ ...selectCategory, showInCategoryHomepageOrder: null }, 'isUpdated');

            if (updateCatgoryData?.data?.response?.id) {
              const updateCatgoryData2ndTime = await onSubmit(getValues());
              setShowModalUpdateConfirm(false)
            }


          }}>Confirm</Button>
        </Modal.Footer>
      </CustomModal> */}
      {/* <DeleteModal
                showModal={showModalUpdateConfirm}
                // loading={deleteLoading}
                setShowModal={setShowModalUpdateConfirm}
                data={{}}
                handleSubmit={() => {

                }}
            /> */}
    </React.Fragment>
  );
};

export default Categories;
